import { memo } from 'react';
import { useState } from 'react';
import { TableCell, TableHead, TableRow, Typography, Button } from '@mui/material';
import AddAirPort from './AddAirPort';
import { Dialog } from '../../style-guide';

const AirPortHeader = () => {
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = () => setOpenOrderModal(true);
    const onHandleCancelModal = () => setOpenOrderModal(false);

    return (
        <TableHead>
            <TableRow>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        Name
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        Country
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        Operations 
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        <Button onClick={onHandleOpenModal} variant='contained'>
                            + New AirPort
                        </Button>
                        {openOrderModal && (
                            <Dialog open={openOrderModal} title={'AirPort'} onHandleCancel={onHandleCancelModal}>
                                <AddAirPort onHandleCancel={onHandleCancelModal} id={null} />
                            </Dialog>
                        )}
                    </Typography>
                </TableCell>

            </TableRow>
        </TableHead>
    );
};

export default memo(AirPortHeader);
